import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('my-enter-search', {
    staticClass: "mb-10",
    attrs: {
      "data-sign": "inventory_age_list_form"
    },
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "data-permission": "inventory_age_list_code_field",
      "id": "inventory_age_list_code_field",
      "allow-clear": false
    },
    model: {
      value: _vm.codeField,
      callback: function ($$v) {
        _vm.codeField = $$v;
      },
      expression: "codeField"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "product_sku_list"
    }
  }, [_vm._v(_vm._s(_vm.t('商品编码')))]), _c('a-select-option', {
    attrs: {
      "value": "product_barcode_list"
    }
  }, [_vm._v(_vm._s(_vm.t('谷仓商品条码')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "data-permission": "inventory_age_list_dblclick",
      "id": "inventory_age_list_dblclick",
      "data-sign": "inventory_age_list_dblclick",
      "placeholder": _vm.t('common', '双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick,
      "change": _vm.handleCodeChange
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  }, [_c('div', {
    attrs: {
      "slot": "addonAfter"
    },
    slot: "addonAfter"
  }, [_c('a-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.isDisabledFuzzyCode ? _vm.t('多个编码不支持模糊查询') : _vm.t('是否模糊搜索')))]), _c('a-checkbox', {
    attrs: {
      "id": "inventory_age_list_dblclick_is_fuzzy",
      "disabled": _vm.isDisabledFuzzyCode,
      "checked": !!_vm.searchData.is_fuzzy_code
    },
    on: {
      "change": _vm.handleFuzzyChange
    }
  }), _vm._v(" " + _vm._s(_vm.t('模糊')) + " ")], 1)], 1)])], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "data-permission": "inventory_age_list_doc_type",
      "id": "inventory_age_list_doc_type",
      "allow-clear": false
    },
    model: {
      value: _vm.docType,
      callback: function ($$v) {
        _vm.docType = $$v;
      },
      expression: "docType"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "product_title"
    }
  }, [_vm._v(_vm._s(_vm.t('商品中文名称')))]), _c('a-select-option', {
    attrs: {
      "value": "product_title_en"
    }
  }, [_vm._v(_vm._s(_vm.t('商品英文名称')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u8BF7\u8F93\u5165"),
      "data-permission": "inventory_age_list_doc_name_value",
      "id": "inventory_age_list_doc_name_value",
      "placeholder": _vm.t('请输入')
    },
    model: {
      value: _vm.docNameValue,
      callback: function ($$v) {
        _vm.docNameValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docNameValue"
    }
  })], 1), _c('div', {
    staticClass: "form-item-inline",
    staticStyle: {
      "vertical-align": "bottom",
      "line-height": "32px"
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u8D85\u51FA\u5E93\u9F84\u9884\u8B66"),
      "data-permission": "inventory_age_list_warning_age_type",
      "id": "inventory_age_list_warning_age_type",
      "show-tip": "",
      "placeholder": _vm.t('是否超出库龄预警'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.warning_age_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warning_age_type", $$v);
      },
      expression: "searchData.warning_age_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v(_vm._s(_vm.tc('超出')))]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v(_vm._s(_vm.tc('未超出')))])], 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('库龄')))])], 1), _c('a-input-number', {
    staticStyle: {
      "width": "100px",
      "text-align": "center"
    },
    attrs: {
      "data-permission": "inventory_age_list_age_from",
      "id": "inventory_age_list_age_from",
      "min": 0,
      "max": 9999,
      "formatter": _vm.formatter,
      "step": 1,
      "placeholder": ""
    },
    model: {
      value: _vm.searchData.age_from,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "age_from", $$v);
      },
      expression: "searchData.age_from"
    }
  }), _c('a-input', {
    staticStyle: {
      "width": "30px",
      "border-left": "0",
      "pointer-events": "none",
      "backgroundColor": "#fff"
    },
    attrs: {
      "fbu-analyse-name":
      /*no-i18n-auto*/
      '~',
      "placeholder": "~",
      "disabled": ""
    }
  }), _c('a-input-number', {
    staticStyle: {
      "width": "100px",
      "text-align": "center",
      "border-left": "0"
    },
    attrs: {
      "data-permission": "inventory_age_list_age_to",
      "id": "inventory_age_list_age_to",
      "min": 0,
      "max": 9999,
      "formatter": _vm.formatter,
      "step": 1,
      "placeholder": ""
    },
    model: {
      value: _vm.searchData.age_to,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "age_to", $$v);
      },
      expression: "searchData.age_to"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('在库库存')))])], 1), _c('a-input-number', {
    staticStyle: {
      "width": "100px",
      "text-align": "center"
    },
    attrs: {
      "data-permission": "inventory_age_list_quantity_from",
      "id": "inventory_age_list_quantity_from",
      "min": 0,
      "max": 999999999,
      "placeholder": ""
    },
    model: {
      value: _vm.searchData.quantity_from,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "quantity_from", $$v);
      },
      expression: "searchData.quantity_from"
    }
  }), _c('a-input', {
    staticStyle: {
      "width": "30px",
      "border-left": "0",
      "pointer-events": "none",
      "backgroundColor": "#fff"
    },
    attrs: {
      "placeholder": "~",
      "disabled": ""
    }
  }), _c('a-input-number', {
    staticStyle: {
      "width": "100px",
      "text-align": "center",
      "border-left": "0"
    },
    attrs: {
      "data-permission": "inventory_age_list_quantity_to",
      "id": "inventory_age_list_quantity_to",
      "min": 0,
      "max": 999999999,
      "placeholder": ""
    },
    model: {
      value: _vm.searchData.quantity_to,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "quantity_to", $$v);
      },
      expression: "searchData.quantity_to"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u8BF7\u9009\u62E9\u4ED3\u5E93"),
      "data-permission": "inventory_age_list_warehouse_code",
      "id": "inventory_age_list_warehouse_code",
      "placeholder": _vm.t('请选择仓库'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(_vm._s(item.warehouse_name_text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "data-permission": "inventory_age_list_date_type",
      "id": "inventory_age_list_date_type",
      "allow-clear": false,
      "value": "1"
    },
    model: {
      value: _vm.searchData.date_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "date_type", $$v);
      },
      expression: "searchData.date_type"
    }
  }, _vm._l(_vm.inventoryAgeListDateTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "id": 'inventory_age_list_date_type_' + item.value,
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "inventory_age_list_date_value",
      "id": "inventory_age_list_date_value",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-permission": "inventory_age_list_search",
      "id": "inventory_age_list_search",
      "data-sign": "inventory_age_list_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-permission": "inventory_age_list_reset",
      "id": "inventory_age_list_reset",
      "data-sign": "inventory_age_list_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedIdList.length))]), _c('a-dropdown', {
    attrs: {
      "data-permission": "inventory_age_list_export",
      "id": "inventory_age_list_export"
    }
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "inventory_age_list_export_all",
      "id": "inventory_age_list_export_all",
      "data-sign": "inventory_age_list_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "inventory_age_list_export_selected",
      "id": "inventory_age_list_export_selected",
      "data-sign": "inventory_age_list_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'inventory_update_warn_age',
      expression: "'inventory_update_warn_age'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "inventory_age_list_update_warn_age",
      "id": "inventory_age_list_update_warn_age",
      "data-sign": "inventory_age_list_update_warn_age",
      "fbu-analyse-name": $t("\u6279\u91CF\u8BBE\u7F6E\u9884\u8B66\u5E93\u9F84")
    },
    on: {
      "click": _vm.handleSetInventoryBluk
    }
  }, [_vm._v(_vm._s(_vm.t('批量设置预警库龄')))])], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "fixed-header": "",
      "useMouseTool": "",
      "is-filter-box": "",
      "name": "inventoryAgeList",
      "data-sign": "inventory_age_list_table",
      "row-selection": _vm.rowSelection,
      "data-source": _vm.dataList,
      "row-key": "iba_id"
    },
    scopedSlots: _vm._u([{
      key: "product_sku",
      fn: function (ref) {
        var record = ref.record;
        return [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.product_sku,
            expression: "record.product_sku"
          }],
          attrs: {
            "to": {
              name: 'ProductDetail',
              query: {
                sku: record.product_sku,
                name: _vm.$route.name
              },
              params: {
                noCache: 1
              }
            },
            "data-sign": "inventory_age_list_item_product_sku"
          }
        }, [_vm._v(" " + _vm._s(record.product_sku) + " ")])];
      }
    }, {
      key: "product_title",
      fn: function (ref) {
        var record = ref.record;
        return [_c('text-ellipses', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.product_title,
            expression: "record.product_title"
          }],
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "data": record.product_title
          }
        })];
      }
    }, {
      key: "product_title_en",
      fn: function (ref) {
        var record = ref.record;
        return [_c('text-ellipses', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.product_title_en,
            expression: "record.product_title_en"
          }],
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "data": record.product_title_en
          }
        })];
      }
    }, {
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.warehouse_code ? _c('div', [_vm._v(_vm._s(record.warehouse_code) + "[" + _vm._s(record.warehouse_desc) + "]")]) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])]);
      }
    }, {
      key: "warehouse_age",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', {
          class: {
            'warn-color': record.warehouse_age > record.iba_warning_age
          }
        }, [_vm._v(_vm._s(record.warehouse_age))])]);
      }
    }, {
      key: "iba_warning_age",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(record.iba_warning_age) + " "), _c('a-popover', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'inventory_update_warn_age',
            expression: "'inventory_update_warn_age'"
          }],
          attrs: {
            "trigger": "click",
            "placement": "topLeft",
            "visible": record._visible
          }
        }, [_c('template', {
          slot: "content"
        }, [_c('div', {
          staticClass: "flex-box"
        }, [_c('a-input-number', {
          staticClass: "flex-item",
          attrs: {
            "max": 9999,
            "formatter": _vm.formatter,
            "min": 0,
            "step": 1
          },
          model: {
            value: record._iba_warning_age,
            callback: function ($$v) {
              _vm.$set(record, "_iba_warning_age", $$v);
            },
            expression: "record._iba_warning_age"
          }
        }), _c('span', [_c('a-button', {
          staticClass: "ml-5",
          attrs: {
            "type": "primary",
            "ghost": "",
            "loading": _vm.updateWarnValueLoading,
            "data-sign": "inventory_age_list_item_update_warn_age_update",
            "fbu-analyse-name": $t("\u66F4\u65B0")
          },
          on: {
            "click": function ($event) {
              return _vm.handleUpdateWarn(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('更新')))]), _c('a-button', {
          staticClass: "ml-5",
          attrs: {
            "data-sign": "inventory_age_list_item_update_warn_age_cancel",
            "fbu-analyse-name": $t("\u53D6\u6D88")
          },
          on: {
            "click": function ($event) {
              record._visible = false;
            }
          }
        }, [_vm._v(_vm._s(_vm.t('取消')))])], 1)], 1)]), _c('a-button', {
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "type": "link",
            "data-sign": "inventory_age_list_item_update_warn_age",
            "size": "small"
          },
          on: {
            "click": function ($event) {
              return _vm.handleShowWarningAgeBox(record);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "edit"
          }
        })], 1)], 2)], 1);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "name": "inventoryAgeList",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('set-warn', {
    ref: "setInventoryWarnRef",
    attrs: {
      "data": _vm.selectedList
    },
    on: {
      "success": _vm.handleSuccess
    }
  }), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };